import { useLocation, matchPath } from 'react-router-dom';

import { getRoutes, RouteItem } from '../routes';

export function useActiveRoute(): RouteItem | undefined {
  const { pathname } = useLocation();
  const routes = Object.values(getRoutes());
  return routes.find((route) => matchPath(route.path, pathname));
}
